import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DOCUMENT } from "@angular/common";
import { CommonService } from "../common/common.service";

@Component({
  selector: 'toolbox-redirect-error-dialog',
  templateUrl: './redirect-error-dialog.component.html',
  styleUrls: ['./redirect-error-dialog.component.scss']
})
export class RedirectErrorDialogComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: any,
              @Inject(MAT_DIALOG_DATA) public message: string,
              private commonService: CommonService) {
  }

  ngOnInit(): void {
    setTimeout(() => this.commonService.redirectToLoginPageByBrand(), 5000);
  }
}
